import {DELETE, expectOneOf, HttpClient} from '@raison/network-facade';
import {CANCELLATION_ENABLED} from '../constants';
import {TrTxId} from '../model/TrTx';

export function submitTrtCancellation(http: HttpClient, trtId: TrTxId) {
    if (!CANCELLATION_ENABLED) {
        throw new Error('Cancellation is disabled');
    }
    // this isn't yet implemented
    return http(`v1/travel_rule/cancel/${trtId}`, DELETE()).then(
        expectOneOf({
            200: null,
            401: null,
        })
    );
}
